import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toggleAdminMode } from "../../redux/slices/adminModeSlice";

const ProfileHeader = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isSuperUser = useSelector((state) => state.isAdmin.isSuperUser);
    const adminMode = useSelector((state) => state.adminMode.adminMode);

    // Переключение режима администратора
    const handleToggleAdminMode = () => {
        dispatch(toggleAdminMode());
    };

    return (
        <div className="profile-header">
            {/* Кнопка администратора */}
            {isSuperUser && (
                <>
                    <button
                        className={`admin-mode-btn ${adminMode ? "admin-active" : "admin-inactive"}`}
                        onClick={handleToggleAdminMode}
                    >
                        {adminMode ? "Disable admin mode" : "Enable admin mode"}
                    </button>
                    <button
                        className="admin-mode-btn admin-inactive"
                        onClick={() => navigate('/admin')}
                    >
                        Открыть веб-админку
                    </button>
                </>
            )}
        </div>
    );
};

export default ProfileHeader; 